<template>
  <div class="page">

    <!-- 搜索 -->
    <el-form v-if="isShowSearch" :model="queryForm" ref="form" label-width="80px" :inline="true" size="small" class="query-form" @submit.native.prevent>
      <!--el-form-item label="店铺">
        <GridSelect
          style="width: 180px"
          title="选择店铺"
          labelName="shopName"
          labelValue="id"
          :value="queryForm.shopId"
          :limit="1"
          size="small"
          placeholder="请选择店铺"
          @getValue="(value) => { queryForm.shopId = value }"
          :columns="SHOP_code"
          :searchs="SHOP_search"
          dataListUrl="/mall/shop/findList"
          entityBeanName="mallShop"
          queryEntityUrl="/mall/shop/get"
        ></GridSelect>
      </el-form-item-->
      <!--el-form-item label="门店">
        <GridSelect
          style="width: 180px"
          title="选择门店"
          labelName="storeName"
          labelValue="id"
          :value="queryForm.storeId"
          :limit="1"
          size="small"
          placeholder="请选择门店"
          @getValue="(value) => { queryForm.storeId = value }"
          :columns="STORE_code"
          :searchs="STORE_search"
          dataListUrl="/shop/store/findList"
          entityBeanName="shopStore"
          queryEntityUrl="/shop/store/get"
        ></GridSelect>
      </el-form-item-->
      <el-form-item label="类型">
        <el-select
          v-model="queryForm.amountTypes"
          placeholder="请选择类型"
          clearable
          size="small"
          style="width: 180px">
          <el-option label="个人业绩" value="type1"></el-option>
          <el-option label="团队业绩" value="type2"></el-option>
          <el-option label="个人让利" value="type3"></el-option>
          <el-option label="团队让利" value="type4"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="创建时间">
        <el-date-picker
          style="width: 340px"
          v-model="timeRange"
          type="datetimerange"
          format="yyyy-MM-dd HH:mm:ss"
          value-format="yyyy-MM-dd HH:mm:ss"
          range-separator="-"
          start-placeholder="开始时间"
          end-placeholder="结束时间">
        </el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="getShopUserReportRecordList">查询</el-button>
        <el-button size="small" icon="el-icon-refresh" @click="resetDialog">重置</el-button>
      </el-form-item>
	  
	  <div>
		  共计金额：{{totalAmount}}
	  </div>
    </el-form>

    <!-- 页面内容 -->
    <div class="page-content">
      <div class="page-tool-bar">

        <!-- 批量操作 -->
        <div class="el-btn-group">
          <el-button
            type="primary"
            size="small"
            icon="el-icon-plus"
            @click="addShopUserReportRecord"
          >新建</el-button>
          <el-button
            type="warning"
            plain
            size="small"
            icon="el-icon-edit"
            :disabled="multipleSelection.length != 1"
            @click="editShopUserReportRecord(null)"
          >修改</el-button>
          <el-button
            type="danger"
            plain
            size="small"
            icon="el-icon-delete"
            :disabled="multipleSelection.length <= 0"
            @click="deleteShopUserReportRecord(null)"
          >删除</el-button>
        </div>

        <!-- 导入导出查询 -->
        <div class="icon-group">
          <el-upload v-if="this.isShowImport"
            class="upload-demo"
            action="#"
            :http-request="importShopUserReportRecordData"
            :show-file-list="true">
            <el-button size="small" type="primary">点击上传</el-button>
            <div slot="tip" class="el-upload__tip">只允许导入“xls”或“xlsx”格式文件！</div>
          </el-upload>
          <span
            title="搜索"
            class="icon-box"
            @click="showHiddenSearch">
            <Icon color="#606266">
              <Search />
            </Icon>
          </span>
          <span
            title="导出数据"
            class="icon-box"
            @click="exportUserReportRecordList"
          >
            <Icon color="#606266">
            <ArrowDownload24Regular />
            </Icon>
          </span>
          <span
            class="icon-box"
            @click="refreshShopUserReportRecordList">
            <Icon color="#606266">
              <Refresh />
            </Icon>
          </span>
        </div>
      </div>

      <!-- 分页列表 -->
      <el-table
        :data="shopUserReportRecordList"
        row-key="id"
        border
        height="100%"
        :header-row-style="{height: '10px'}"
        :header-cell-style="{padding: '10px'}"
        :row-style="{height: '9px'}"
        :cell-style="{padding: '9px'}"
        @selection-change="handleSelectionChange"
        size="small">
        <el-table-column
          align="center"
          type="selection"
          width="60">
        </el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          align="center"
          label="来源"
          width="180">
		  <template slot-scope="scope">
		    <div v-if="scope.row">
		      <div style="text-align: left">店铺ID：{{ scope.row.shopId }}</div>
		      <div style="text-align: left">门店ID：{{ scope.row.storeId }}</div>
		      <div style="text-align: left">订单ID：{{ scope.row.reportId }}</div>
		    </div>
		    <div v-else>--</div>
		  </template>
        </el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          align="center"
          prop="userId"
          label="用户信息"
          width="180">
		  <template slot-scope="scope">
		    <div v-if="scope.row.user">
		      <div style="text-align: left">账号：{{ scope.row.user.userName }}</div>
		      <div style="text-align: left">手机：{{ scope.row.user.userMobile }}</div>
		      <div style="text-align: left">昵称：{{ scope.row.user.userNickname }}</div>
		      <div style="text-align: left">姓名：{{ scope.row.user.userRealname }}</div>
		    </div>
		    <div v-else>--</div>
		  </template>
        </el-table-column>
        <!--el-table-column
          :show-overflow-tooltip="true"
          align="center"
          prop="shopId"
          label="店铺"
          width="180">
        </el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          align="center"
          prop="storeId"
          label="门店"
          width="180">
        </el-table-column-->
        <el-table-column
          :show-overflow-tooltip="true"
          align="center"
          prop="amount"
          label="数量"
          width="180">
        </el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          align="center"
          prop="amountTypes"
          label="类型"
          width="180">
        </el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          align="center"
          prop="parentPath"
          label="父路径"
          width="180">
        </el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          align="center"
          prop="createTime"
          label="创建时间"
          width="180">
        </el-table-column>
        <el-table-column
          fixed="right"
          align="center"
          label="操作"
          width="300">
          <template slot-scope="scop">
            <div class="operation">
              <div @click="checkShopUserReportRecord(scop.row.id)">
                <Icon size="16">
                  <Eye24Regular />
                </Icon>
                <span class="operation-label">查看</span>
              </div>
              <div @click="editShopUserReportRecord(scop.row.id)">
                <Icon size="16">
                  <Edit24Regular />
                </Icon>
                <span class="operation-label">修改</span>
              </div>
              <div @click="deleteShopUserReportRecord(scop.row.id)">
                <Icon size="16" style="color: red">
                  <Delete24Regular />
                </Icon>
                <span class="operation-label" style="color: red">删除</span>
              </div>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination-box">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page.sync="currentPage"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="totalNum"
          background
          :pager-count="7">
        </el-pagination>
      </div>

      <!-- 新增/查看/修改 -->
      <el-dialog
        :title="shopUserReportRecordStates[shopUserReportRecordState]"
        :visible.sync="showDialog"
        width="60%"
        @close="closeDialog">
        <div>
          <el-form
            :model="shopUserReportRecord"
            ref="shopUserReportRecordForm"
            :rules="rules"
            label-width="120px"
            :inline="true"
            size="small">
            <el-form-item
              label="报表ID"
              prop="reportId"
              v-if="
                shopUserReportRecordState == 'add' ||
                shopUserReportRecordState == 'check' ||
                shopUserReportRecordState == 'edit' ||
                false
              ">
              <el-input
                size="small"
                v-model="shopUserReportRecord.reportId"
                :disabled="shopUserReportRecordState == 'check'"
                placeholder="请输入报表ID"
                style="width: 200px;">
              </el-input>
            </el-form-item>
            <el-form-item
              label="用户"
              prop="userId"
              v-if="
                shopUserReportRecordState == 'add' ||
                shopUserReportRecordState == 'check' ||
                shopUserReportRecordState == 'edit' ||
                false
              ">
              <el-input
                size="small"
                v-model="shopUserReportRecord.userId"
                :disabled="shopUserReportRecordState == 'check'"
                placeholder="请输入用户"
                style="width: 200px;">
              </el-input>
            </el-form-item>
            <el-form-item
              label="店铺"
              prop="shopId"
              v-if="
                shopUserReportRecordState == 'add' ||
                shopUserReportRecordState == 'check' ||
                shopUserReportRecordState == 'edit' ||
                false
              ">
              <el-input
                size="small"
                v-model="shopUserReportRecord.shopId"
                :disabled="shopUserReportRecordState == 'check'"
                placeholder="请输入店铺"
                style="width: 200px;">
              </el-input>
            </el-form-item>
            <el-form-item
              label="门店"
              prop="storeId"
              v-if="
                shopUserReportRecordState == 'add' ||
                shopUserReportRecordState == 'check' ||
                shopUserReportRecordState == 'edit' ||
                false
              ">
              <el-input
                size="small"
                v-model="shopUserReportRecord.storeId"
                :disabled="shopUserReportRecordState == 'check'"
                placeholder="请输入门店"
                style="width: 200px;">
              </el-input>
            </el-form-item>
            <el-form-item
              label="数量"
              prop="amount"
              v-if="
                shopUserReportRecordState == 'add' ||
                shopUserReportRecordState == 'check' ||
                shopUserReportRecordState == 'edit' ||
                false
              ">
              <el-input
                size="small"
                v-model="shopUserReportRecord.amount"
                :disabled="shopUserReportRecordState == 'check'"
                placeholder="请输入数量"
                style="width: 200px;">
              </el-input>
            </el-form-item>
            <el-form-item
              label="类型"
              prop="amountTypes"
              v-if="
                shopUserReportRecordState == 'add' ||
                shopUserReportRecordState == 'check' ||
                shopUserReportRecordState == 'edit' ||
                false
              ">
              <el-input
                size="small"
                v-model="shopUserReportRecord.amountTypes"
                :disabled="shopUserReportRecordState == 'check'"
                placeholder="请输入类型"
                style="width: 200px;">
              </el-input>
            </el-form-item>
            <el-form-item
              label="父路径"
              prop="parentPath"
              v-if="
                shopUserReportRecordState == 'add' ||
                shopUserReportRecordState == 'check' ||
                shopUserReportRecordState == 'edit' ||
                false
              ">
              <el-input
                size="small"
                v-model="shopUserReportRecord.parentPath"
                :disabled="shopUserReportRecordState == 'check'"
                placeholder="请输入父路径"
                style="width: 200px;">
              </el-input>
            </el-form-item>
          </el-form>
        </div>
        <div
          slot="footer"
          class="flex justify-end">
          <el-button @click="closeDialog">关闭</el-button>
          <el-button
            type="primary"
            @click="submitForm"
            v-if="shopUserReportRecordState != 'check'"
          >确定</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import { GridDots, Refresh, Printer, ArrowUp, ArrowDown, Search } from '@v2icons/tabler';
import { Edit24Regular, Delete24Regular, Eye24Regular } from '@v2icons/fluent';
import { ArrowDownload24Regular, ArrowExportUp24Regular } from '@v2icons/fluent';
import { downloadTemplate, importData, exportExcel, get, post, put, deleteFun, upload, exprotExcel } from '@/utils/request.js';
import GridSelect from '@/components/gridselect';
import { SHOP, SHOP_SEARCH, STORE, STORE_SEARCH } from '@/utils/constant';

export default {
    components: {
        Edit24Regular,
        Delete24Regular,
        Eye24Regular,
        GridDots,
        Refresh,
        Printer,
        ArrowUp,
        ArrowDown,
        ArrowDownload24Regular,
        ArrowExportUp24Regular,
        Search,
        GridSelect
    },
    props: {
        userId: {
            type: String,
            default: ''
        }
    },
    watch: {
        userId(val) {
            if (val) {
                this.resetShopUserReportRecordList();
                this.getShopUserReportRecordList();
            }
        },
        checkState(val) {
            if (val == 'check') {
                this.resetShopUserReportRecordList();
                this.getShopUserReportRecordList(this.queryForm);
                this.$emit('resetCheckState');
            } else if (val == 'reset') {
                this.resetShopUserReportRecordList();
                this.getShopUserReportRecordList();
                this.$emit('resetCheckState');
            }
        }
    },
    data() {
        return {
            SHOP_code: SHOP,
            SHOP_search: SHOP_SEARCH,
            STORE_code: STORE,
            STORE_search: STORE_SEARCH,
            timeRange: [],
            queryForm: {
                id: '',
                reportId: '',
                shopId: '',
                storeId: '',
                amount: '',
                amountTypes: '',
                parentPath: '',
                startTime: '',
                endTime: '',
                createUserId: '',
                updateUserId: '',
                createTime: '',
                updateTime: '',
                deleteFlag: '',
            },
            loading: false,
            showDialog: false,
            isShowSearch: false,
            isShowImport: false,
            downloadLoading: false,
            pageSize: 10,
            currentPage: 1,
            totalNum: 0,
			totalAmount:0,
            currentUserId: '',
            shopUserReportRecordState: 'add',
            shopUserReportRecordStates: {
                add: '新建shop_user_report_record',
                check: '查看shop_user_report_record',
                edit: '修改shop_user_report_record'
            },
            multipleSelection: [],
            shopUserReportRecordList: [],
            shopUserReportRecord: {
                id: '', // 
                reportId: '', // 报表ID
                userId: '', // 用户
                shopId: '', // 店铺
                storeId: '', // 门店
                amount: '', // 数量
                amountTypes: '', // 类型
                parentPath: '', // 父路径
                createUserId: '', // 
                updateUserId: '', // 
                createTime: '', // 
                updateTime: '', // 
                deleteFlag: '', // 
            },
            //下拉/单选/复选框选项，可绑定字典或接口填充
            //文件列表
            rules: {
                reportId: [{ required: true, message: '报表ID不能为空', trigger: 'blur' }],
                userId: [{ required: true, message: '用户不能为空', trigger: 'blur' }],
                shopId: [{ required: true, message: '店铺不能为空', trigger: 'blur' }],
                storeId: [{ required: true, message: '门店不能为空', trigger: 'blur' }],
                amount: [{ required: true, message: '数量不能为空', trigger: 'blur' }],
                amountTypes: [{ required: true, message: '类型不能为空', trigger: 'blur' }],
                parentPath: [{ required: true, message: '父路径不能为空', trigger: 'blur' }],
            }
        };
    },
    created() {
    },
    methods: {
        showHiddenSearch(){
            this.isShowSearch = !this.isShowSearch;
        },
        handleSelectionChange(value) {
            console.log(value);
            this.multipleSelection = value;
        },
        handleSizeChange(size) {
            this.pageSize = size;
            this.getShopUserReportRecordList();
        },
        handleCurrentChange(page) {
            this.currentPage = page;
            this.getShopUserReportRecordList();
        },
        resetShopUserReportRecordList() {
            this.pageSize = 10;
            this.currentPage = 1;
            this.shopUserReportRecordList = [];
        },
        resetDialog() {
            this.shopUserReportRecordState = 'add';
            this.showDialog = false;
            this.timeRange = [];
            this.queryForm = {
                id: '',
                reportId: '',
                shopId: '',
                storeId: '',
                amount: '',
                amountTypes: '',
                parentPath: '',
                startTime: '',
                endTime: '',
                createUserId: '',
                updateUserId: '',
                createTime: '',
                updateTime: '',
                deleteFlag: '',
            };
            this.getShopUserReportRecordList();
        },
        closeDialog() {
            this.showDialog = false;
            this.shopUserReportRecord = {
                id: '',
                reportId: '',
                userId: '',
                shopId: '',
                storeId: '',
                amount: '',
                amountTypes: '',
                parentPath: '',
                createUserId: '',
                updateUserId: '',
                createTime: '',
                updateTime: '',
                deleteFlag: '',
            };
        },
        submitForm() {
            if (this.shopUserReportRecordState == 'add') {
                this.$refs.shopUserReportRecordForm.validate((valid) => {
                    if (valid) {
                        console.log('submit');
                        post(`/shop/userreportrecord/add`,{ ...this.shopUserReportRecord }).then((res) => {
                            if (res.success) {
                                this.$message({
                                    message: res.msg,
                                    type: 'success',
                                    duration: 2000,
                                });
                                this.resetShopUserReportRecordList();
                                this.resetDialog();
                            } else {
                                this.$message({
                                    message: res.msg,
                                    type: 'error',
                                    duration: 2000
                                });
                            }
                        });
                    }
                });
            } else if (this.shopUserReportRecordState == 'edit') {
                this.$refs.shopUserReportRecordForm.validate((valid) => {
                    if (valid) {
                        console.log('submit');
                        post(`/shop/userreportrecord/edit`,{ ...this.shopUserReportRecord }).then((res) => {
                            if (res.success) {
                                this.$message({
                                    message: res.msg,
                                    type: 'success',
                                    duration: 2000
                                });
                                this.resetShopUserReportRecordList();
                                this.resetDialog();
                            } else {
                                this.$message({
                                    message: res.msg,
                                    type: 'error',
                                    duration: 2000
                                });
                            }
                        });
                    }
                });
            }
        },
        addShopUserReportRecord() {
            this.showDialog = true;
            this.shopUserReportRecordState = 'add';
        },
        checkShopUserReportRecord(shopUserReportRecordId) {
            console.log(shopUserReportRecordId);
            this.currentShopUserReportRecordId = shopUserReportRecordId;

            this.getShopUserReportRecordById();
            this.showDialog = true;
            this.shopUserReportRecordState = 'check';
        },
        editShopUserReportRecord(shopUserReportRecordId) {
            console.log('shopUserReportRecord', shopUserReportRecordId);
            if (shopUserReportRecordId) {
                this.currentShopUserReportRecordId = shopUserReportRecordId;
                this.getShopUserReportRecordById();
            } else {
                this.shopUserReportRecord = { ...this.shopUserReportRecord, ...this.multipleSelection[0] };
            }

            this.showDialog = true;
            this.shopUserReportRecordState = 'edit';
        },
        deleteShopUserReportRecord(shopUserReportRecordId) {
            let ids = '';
            if (shopUserReportRecordId) {
                ids = shopUserReportRecordId;
            } else {
                ids = this.multipleSelection.map((shopUserReportRecord) => shopUserReportRecord.id).join(',');
            }
            console.log({ ids });
            this.$confirm('确定删除所选项吗？', '提示', {
                type: 'warning'
            })
                .then(() => {
                    deleteFun(`/shop/userreportrecord/delete`,{ ids }).then((res) => {
                        if (res.success) {
                            this.$message({
                                message: res.msg,
                                type: 'success',
                                duration: 2000
                            });
                            this.resetShopUserReportRecordList();
                            this.getShopUserReportRecordList();
                        } else {
                            this.$message({
                                message: res.msg,
                                type: 'error',
                                duration: 2000
                            });
                        }
                    });
                })
                .catch(() => {});
        },
        exportUserReportRecordList() {
            exprotExcel(`/shop/userreportrecord/exportList`, { ...this.queryForm,  userId: this.userId, pageNum: this.currentPage, pageSize: this.pageSize });
        },
        refreshShopUserReportRecordList() {
            this.resetShopUserReportRecordList();
            this.getShopUserReportRecordList();
        },
        getShopUserReportRecordList(query = {}) {
            this.loading = true;
            if (this.timeRange && this.timeRange.length === 2) {
                this.queryForm.startTime = this.timeRange[0];
                this.queryForm.endTime = this.timeRange[1];
            } else {
                this.queryForm.startTime = '';
                this.queryForm.endTime = '';
            }
            get(`/shop/userreportrecord/findList`,{ ...this.queryForm, userId: this.userId, pageNum: this.currentPage, pageSize: this.pageSize }).then((res) => {
                this.loading = false;
                if (res.success) {
                    this.shopUserReportRecordList = res.page.list;
                    this.totalNum = res.page.total;
					this.totalAmount = res.total;
                } else {
                    this.$message({
                        message: res.msg,
                        type: 'error',
                        duration: 2000
                    });
                }
            });
        },
        getShopUserReportRecordById() {
            get(`/shop/userreportrecord/get`,{ id: this.currentShopUserReportRecordId }).then((res) =>{
                if(res.success){
                  this.shopUserReportRecord = { ...this.shopUserReportRecord, ...res.shopUserReportRecord };
                } else {
                    this.$message({
                        message: res.msg,
                        type: 'error',
                        duration: 2000
                    });
                }
            });
        },
        //下载模板
        downloadTemplate() {
            this.downloadLoading = true;
            downloadTemplate(`/shop/userreportrecord/downloadTemplate`, this.downloadLoading);
        },
        //导出数据
        exportShopUserReportRecordList() {
            //this.downloadLoading = true;
            exportExcel(`/shop/userreportrecord/export`, {...this.queryForm});
        },
        //导入数据
        showImportData() {
            this.isShowImport = !this.isShowImport;
        },
        importShopUserReportRecordData(params){
          const file = params.file;
          const formData = new FormData();
          formData.append('file', file);
          console.log({ formData });
          importData(`/shop/userreportrecord/import`,formData);
          this.refreshShopUserReportRecordList();
        },

    }

};
</script>

<style lang="scss" scoped>

::v-deep .el-dialog__header {
    border-bottom: 1px solid #eee;
}

.operation {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #409eff;
    font-size: 12px;
    & > div {
        display: flex;
        align-items: center;
        padding: 0 5px;
        cursor: pointer;
    }
    .operation-label {
        margin-left: 3px;
    }
}

//上传图片相关-------->start
.avatar {
    width: 200px;
    height: 200px;
    display: block;
}
.avatar-uploader .el-upload:hover {
    border-color: #409eff;
}
.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 200px;
    height: 200px;
    line-height: 200px;
    text-align: center;
}
::v-deep .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    width: 200px;
    height: 200px;
}
//上传图片相关-------->end

</style>